module.exports = __webpack_public_path__ + "static/media/clayton-homes-logo.7ddcd8ad.svg";